<template>
<div>
    <template v-if="discount">
        <div style="padding: 8px 16px;">
            <span style="font-size: 17px; font-weight: 600">{{ $t("plan_calculator.total_without_discount") }} </span>
            <pm-price style="font-size: 17px; font-weight: 600; float: right;" :currency="$store.state.currency" :value="total" />
        </div>
        <div style="padding: 8px 16px;">
            <span style="font-size: 17px; font-weight: 600">{{ $t("plan_calculator.discount") }} </span>
            <pm-price v-if="$store.state.simplePlan.discountMode === 'currency'" style="font-size: 17px; font-weight: 600; float: right;" :currency="$store.state.currency" :value="calculateDiscount()" />
            <span v-else style="font-size: 17px; font-weight: 600; float: right;">
                {{ $store.state.simplePlan.discountAmount }} <small>%</small>
            </span>
        </div>
        <div style="padding: 8px 16px; background: #eee;">
            <span style="font-size: 17px; font-weight: 600">{{ $t("plan_calculator.total_with_discount") }} </span>
            <pm-price style="font-size: 17px; font-weight: 600; float: right;" :currency="$store.state.currency" :value="total - calculateDiscount()" />
        </div>
    </template>
    <template v-else>
        <div style="padding: 8px 16px; background: #eee;">
            <span style="font-size: 17px; font-weight: 600">{{ $t("plan_calculator.total") }} </span>
            <pm-price style="font-size: 17px; font-weight: 600; float: right;" :currency="$store.state.currency" :value="total" />
        </div>
    </template>
</div>
</template>
<script>
import { getFullTotal, calculateDiscount } from "@/components/plan-simple/plan";
export default {
    props: {
        total: {
            type: Number,
            default: 0,
        },
        discount: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        calculateDiscount() {
            return calculateDiscount();
        }
    }
}
</script>
